'use client';

import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import ROUTES from '@utils/routes';
import { Button } from 'designSystem/Buttons/Buttons';
import { Flex } from 'designSystem/Layouts/Layouts';
import { Text } from 'designSystem/Texts/Texts';
import Image from 'next/image';

export default function PVBanner({
  type = 'pv',
  className = '',
  isFloating = false,
}: {
  type?: 'pv' | 'asesoramientoPiel' | 'asesoramientoLongevidad' | 'surgery';
  className?: string;
  isFloating?: boolean;
}) {
  // isMobile (react-device-detect) difiere entre servidor y cliente; el
  // banner ahora se pinta en servidor dentro de la lista de categorías.
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const BANNER_CONFIG = {
    pv: {
      imgSrc: '/images/statics/landings/PV/PV2.webp',
      imgAlt:
        'Descubre tu tratamiento ideal con nuestro probador virtual gratis',
      title: 'Descubre tu tratamiento ideal',
      subtitle: 'Te asesoramos sin compromiso',
      buttonText: 'Pide cita',
      buttonHref: ROUTES.landings.pv,
      imgStyles: 'w-1/2 md:w-full',
    },
    asesoramientoPiel: {
      imgSrc: '/images/statics/landings/PV/start-landing-piel.webp',
      imgAlt: 'Descubre el tratamiento adecuado para tu tipo de piel',
      title: 'Te asesoramos sin compromiso',
      subtitle: 'Descubre el tratamiento adecuado para tu tipo de piel',
      buttonText: 'Pide cita',
      buttonHref: ROUTES.landings.aesthetic,
      imgStyles: 'w-1/2 md:w-full',
    },
    asesoramientoLongevidad: {
      imgSrc: '/images/home/longevidad2.png',
      imgAlt: 'Descubre el tratamiento adecuado para tu tipo de piel',
      title: 'Plan de longevidad personalizado',
      subtitle: 'Consulta con un especialista en medicina antiaging',
      buttonText: 'Pide cita',
      buttonHref: ROUTES.landings.longevity,
      imgStyles: 'w-1/3 md:w-full',
    },
    surgery: {
      imgSrc: '/images/home/surgeryCard.jpg',
      imgAlt: 'Descubre la cirugía ideal para ti, con valoración experta.',
      title: 'Te asesoramos sin compromiso',
      subtitle: 'Descubre la cirugía ideal para ti, con valoración experta.',
      buttonText: 'Pide cita',
      buttonHref: ROUTES.landings.surgery,
      imgStyles: 'w-1/3 md:w-full',
    },
  };

  return (
    <a href={BANNER_CONFIG[type].buttonHref}>
      <Flex
        layout="row-left"
        className={`w-full ${
          isFloating
            ? 'bg-white'
            : 'bg-derma-secondary500 rounded-2xl overflow-hidden'
        } md:h-full md:flex-col items-stretch ${className} ${
          isFloating ? 'shadow-centered-black' : ''
        }`}
      >
        <div
          className={`relative shrink-0 ${BANNER_CONFIG[type].imgStyles} md:rounded-t-2xl bg-hg-black500/10 overflow-hidden md:aspect-[6/5]`}
        >
          <Image
            src={BANNER_CONFIG[type].imgSrc}
            alt="Descubre tu tratamiento ideal con nuestro probador virtual gratis"
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            className="object-cover"
            priority
          />
        </div>
        <Flex layout="col-left" className="p-4 md:items-center">
          <Text className="font-semibold mb-2 md:text-center md:text-lg">
            {BANNER_CONFIG[type].title}
          </Text>
          <Text size="xs" className="text-hg-black500 md:text-center">
            {BANNER_CONFIG[type].subtitle}
          </Text>

          {BANNER_CONFIG[type].buttonText && (
            <Button
              className="mt-4"
              id={
                isFloating
                  ? 'tmevent_floating_minicard_pv'
                  : 'tmevent_minicard_pv'
              }
              type="secondary"
              size={mounted && isMobile ? 'sm' : 'md'}
            >
              {BANNER_CONFIG[type].buttonText}
            </Button>
          )}
        </Flex>
      </Flex>
    </a>
  );
}
